import { memo } from 'react';
import TextCollectionPerResponseTaskComponent from './TextCollectionPerResponseTaskComponent';
import { StepViewComponentProps } from '../../stepDescriptor/types';

function TextCollectionPerResponsePinnedViewComponent(props: StepViewComponentProps) {
  return <TextCollectionPerResponseTaskComponent {...props} isPinnable isPinnedView />;
}

export default memo(TextCollectionPerResponsePinnedViewComponent);
